import loadable from "utils/loadable";

export const HalamanUploadMemberArea = loadable(() => import("./index"));
export const PopupData = loadable(() => import("./PopupData"));
